
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function GunDrilling() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#001E3C] via-[#002D5C] to-[#001E3C]">
      <Navbar />

      {/* Hero Section with Video */}
      <section className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-6">
              <div className="inline-block">
                <span className="px-4 py-2 bg-[#00D9C9]/10 text-[#00D9C9] rounded-full text-sm font-semibold border border-[#00D9C9]/20">
                  Advanced Manufacturing Technology
                </span>
              </div>
              
              <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight">
                Gun Drilling
                <span className="block bg-gradient-to-r from-[#00D9C9] to-[#00F5E0] bg-clip-text text-transparent">
                  Systems
                </span>
              </h1>
              
              <p className="text-xl text-white/80 leading-relaxed">
                HI-TAK's precision gun drilling technology delivers exceptional accuracy and efficiency for deep hole drilling applications across medical, automotive, and aerospace industries.
              </p>
            </div>

            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-[#00D9C9]/30 to-[#00F5E0]/30 rounded-3xl blur-3xl animate-pulse"></div>
              <div className="relative rounded-3xl overflow-hidden border-2 border-white/20 shadow-2xl transform hover:scale-105 transition-transform duration-500">
                <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                  <iframe
                    className="absolute top-0 left-0 w-full h-full"
                    src="https://www.youtube.com/embed/8SbWEb05OMs?si=mtIEcBTCbiz_ww8D"
                    title="HI-TAK Gun Drilling Systems"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-24 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-20">
            <span className="text-[#00D9C9] text-sm font-bold tracking-widest uppercase">Our Advantages</span>
            <h2 className="text-4xl lg:text-6xl font-bold text-[#001E3C] mt-4 mb-6">
              Why Choose HI-TAK Gun Drilling Systems
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-20">
            <div className="group bg-white rounded-2xl p-10 hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-[#00D9C9]">
              <div className="w-20 h-20 bg-gradient-to-br from-[#00D9C9] to-[#00F5E0] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-hospital-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#001E3C] mb-4">60+ Medical Device Manufacturers</h3>
              <p className="text-gray-600 leading-relaxed">Trusted partnerships built on meeting the highest quality standards in the medical industry.</p>
            </div>

            <div className="group bg-white rounded-2xl p-10 hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-[#00D9C9]">
              <div className="w-20 h-20 bg-gradient-to-br from-[#00D9C9] to-[#00F5E0] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-lightbulb-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#001E3C] mb-4">Decades of Expertise</h3>
              <p className="text-gray-600 leading-relaxed">Deep understanding of customer challenges, offering optimal processing solutions.</p>
            </div>

            <div className="group bg-white rounded-2xl p-10 hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-[#00D9C9]">
              <div className="w-20 h-20 bg-gradient-to-br from-[#00D9C9] to-[#00F5E0] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-customer-service-2-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#001E3C] mb-4">Comprehensive Support</h3>
              <p className="text-gray-600 leading-relaxed">Complete after-sales maintenance and technical support for peace of mind.</p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#001E3C] via-[#003D5C] to-[#001E3C] rounded-3xl p-12 lg:p-16 text-white relative overflow-hidden">
            <div className="absolute inset-0 opacity-5">
              <div className="absolute inset-0" style={{
                backgroundImage: `radial-gradient(circle, #00D9C9 2px, transparent 2px)`,
                backgroundSize: '50px 50px'
              }}></div>
            </div>
            <div className="relative z-10">
              <h3 className="text-3xl lg:text-4xl font-bold mb-10">HI-TAK's Deep Hole Drilling Technology</h3>
              <div className="grid md:grid-cols-3 gap-10">
                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 bg-[#00D9C9]/20 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-settings-3-line text-3xl text-[#00D9C9]"></i>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold mb-2">Proprietary Hollow Spindle Motor</h4>
                      <p className="text-white/80 leading-relaxed">Low vibration, high output for stable, high-precision machining.</p>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 bg-[#00D9C9]/20 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-award-line text-3xl text-[#00D9C9]"></i>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold mb-2">International Patent Technology</h4>
                      <p className="text-white/80 leading-relaxed">Unique mechanisms enabling L/D400 deep hole drilling.</p>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <div className="w-14 h-14 bg-[#00D9C9]/20 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-database-2-line text-3xl text-[#00D9C9]"></i>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold mb-2">Extensive Processing Data</h4>
                      <p className="text-white/80 leading-relaxed">Optimal machining conditions based on years of accumulated data.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Machine Lineup Section */}
      <section className="py-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-20">
            <span className="text-[#00D9C9] text-sm font-bold tracking-widest uppercase">Product Lineup</span>
            <h2 className="text-4xl lg:text-6xl font-bold text-[#001E3C] mt-4 mb-6">
              Diverse Solutions for Every Application
            </h2>
          </div>

          <div className="space-y-16">
            {/* Relative Rotation Type */}
            <div className="group bg-gradient-to-br from-gray-50 to-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200">
              <div className="grid md:grid-cols-2 gap-0">
                <div className="p-10 lg:p-14 flex flex-col justify-center">
                  <h3 className="text-3xl lg:text-4xl font-bold text-[#001E3C] mb-6">Relative Rotation Type Small Diameter Gun Drill</h3>
                  <p className="text-gray-600 mb-8 text-lg leading-relaxed">
                    High-precision model for medical, aerospace, and semiconductor applications
                  </p>
                  <ul className="space-y-4 mb-10">
                    <li className="flex items-start gap-4">
                      <i className="ri-checkbox-circle-fill text-[#00D9C9] text-2xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700 text-lg">Supports hole diameters φ0.5~13mm</span>
                    </li>
                    <li className="flex items-start gap-4">
                      <i className="ri-checkbox-circle-fill text-[#00D9C9] text-2xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700 text-lg">High-precision deep hole drilling exceeding L/D200</span>
                    </li>
                  </ul>
                  <a
                    href="https://www.hi-tak.co.jp/%e3%83%8f%e3%82%a4%e3%82%bf%e3%83%83%e3%82%af%e3%81%ae%e7%b2%be%e5%af%86%e5%b0%8f%e5%be%84%e6%b7%b1%e7%a9%b4%e5%8a%a0%e5%b7%a5%e6%a9%9f-jdh-sdh-600-rf/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 bg-[#00D9C9] text-[#001E3C] px-8 py-4 rounded-xl font-bold hover:bg-[#00F5E0] transition-all duration-300 whitespace-nowrap cursor-pointer w-fit"
                  >
                    Learn More
                    <i className="ri-arrow-right-line text-xl w-6 h-6 flex items-center justify-center"></i>
                  </a>
                </div>
                <div className="relative h-[450px]">
                  <img
                    src="https://www.hi-tak.co.jp/wp-content/uploads/2021/01/gundrilling.png"
                    alt="JDH-600-RF Relative Rotation Type Precision Small Diameter Deep Hole Drilling Machine"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>
            </div>

            {/* Compact Table Type */}
            <div className="group bg-gradient-to-br from-gray-50 to-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200">
              <div className="grid md:grid-cols-2 gap-0">
                <div className="relative h-[450px] order-2 md:order-1">
                  <img
                    src="https://www.hi-tak.co.jp/wp-content/uploads/2024/05/image-1024x710.png"
                    alt="Precision Table Type Gun Drilling Machine"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div className="p-10 lg:p-14 flex flex-col justify-center order-1 md:order-2">
                  <h3 className="text-3xl lg:text-4xl font-bold text-[#001E3C] mb-6">Compact Table Small Diameter Gun Drill</h3>
                  <p className="text-gray-600 mb-8 text-lg leading-relaxed">
                    Ideal for multi-hole drilling on square and irregular workpieces
                  </p>
                  <ul className="space-y-4 mb-10">
                    <li className="flex items-start gap-4">
                      <i className="ri-checkbox-circle-fill text-[#00D9C9] text-2xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700 text-lg">Space-saving compact design</span>
                    </li>
                    <li className="flex items-start gap-4">
                      <i className="ri-checkbox-circle-fill text-[#00D9C9] text-2xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700 text-lg">Smooth machining with servo motor drive</span>
                    </li>
                  </ul>
                  <a
                    href="https://www.hi-tak.co.jp/%e7%b2%be%e5%af%86-%e3%83%86%e3%83%bc%e3%83%96%e3%83%ab-%e3%82%ac%e3%83%b3%e3%83%89%e3%83%aa%e3%83%ab-%e3%83%9e%e3%82%b7%e3%83%b3/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 bg-[#00D9C9] text-[#001E3C] px-8 py-4 rounded-xl font-bold hover:bg-[#00F5E0] transition-all duration-300 whitespace-nowrap cursor-pointer w-fit"
                  >
                    Learn More
                    <i className="ri-arrow-right-line text-xl w-6 h-6 flex items-center justify-center"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Simple Table Type */}
            <div className="group bg-gradient-to-br from-gray-50 to-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200">
              <div className="grid md:grid-cols-2 gap-0">
                <div className="p-10 lg:p-14 flex flex-col justify-center">
                  <h3 className="text-3xl lg:text-4xl font-bold text-[#001E3C] mb-6">Simple Table Type Small Diameter Gun Drill</h3>
                  <p className="text-gray-600 mb-8 text-lg leading-relaxed">
                    Handles complex workpiece shapes with ease
                  </p>
                  <ul className="space-y-4 mb-10">
                    <li className="flex items-start gap-4">
                      <i className="ri-checkbox-circle-fill text-[#00D9C9] text-2xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700 text-lg">Easy operation, perfect for beginners</span>
                    </li>
                    <li className="flex items-start gap-4">
                      <i className="ri-checkbox-circle-fill text-[#00D9C9] text-2xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700 text-lg">Extensive automation options available</span>
                    </li>
                  </ul>
                  <a
                    href="https://www.hi-tak.co.jp/%e9%ab%98%e7%b2%be%e5%ba%a6-%e5%b0%8f%e5%9e%8b-%e6%b2%bb%e5%85%b7-%e3%83%86%e3%83%bc%e3%83%96%e3%83%ab/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 bg-[#00D9C9] text-[#001E3C] px-8 py-4 rounded-xl font-bold hover:bg-[#00F5E0] transition-all duration-300 whitespace-nowrap cursor-pointer w-fit"
                  >
                    Learn More
                    <i className="ri-arrow-right-line text-xl w-6 h-6 flex items-center justify-center"></i>
                  </a>
                </div>
                <div className="relative h-[450px]">
                  <img
                    src="https://www.hi-tak.co.jp/wp-content/uploads/2017/03/28cb6de72f443a69356a817e17a04d6d-e1490154521798.jpg"
                    alt="Simple Table Type Small Diameter Gun Drilling Machine"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>
            </div>

            {/* Custom Solutions */}
            <div className="group bg-gradient-to-br from-gray-50 to-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200">
              <div className="grid md:grid-cols-2 gap-0">
                <div className="relative h-[450px] order-2 md:order-1">
                  <img
                    src="https://www.hi-tak.co.jp/wp-content/uploads/2024/05/IMG_0020-1024x768.jpg"
                    alt="Custom Solutions"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div className="p-10 lg:p-14 flex flex-col justify-center order-1 md:order-2">
                  <h3 className="text-3xl lg:text-4xl font-bold text-[#001E3C] mb-6">Custom Solutions</h3>
                  <p className="text-gray-600 mb-8 text-lg leading-relaxed">
                    Tailored table-type and multi-spindle machines for φ0.5~30mm, customized to your specific needs
                  </p>
                  <ul className="space-y-4 mb-10">
                    <li className="flex items-start gap-4">
                      <i className="ri-checkbox-circle-fill text-[#00D9C9] text-2xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700 text-lg">Flexible design based on customer requirements</span>
                    </li>
                    <li className="flex items-start gap-4">
                      <i className="ri-checkbox-circle-fill text-[#00D9C9] text-2xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700 text-lg">Multi-axis machining capabilities</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-20">
            <span className="text-[#00D9C9] text-sm font-bold tracking-widest uppercase">Key Features</span>
            <h2 className="text-4xl lg:text-6xl font-bold text-[#001E3C] mt-4 mb-6">
              Three Distinctive Features of HI-TAK Gun Drills
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-10">
            <div className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100">
              <h3 className="text-2xl font-bold text-[#001E3C] mb-6">Low Vibration Spindle Motor</h3>
              <p className="text-gray-600 mb-8 leading-relaxed text-lg">
                Minimized vibration ensures high-precision and repeatable accuracy in every operation.
              </p>
              <div className="w-full h-[220px] rounded-xl overflow-hidden">
                <img
                  src="https://www.hi-tak.co.jp/wp-content/uploads/2021/01/tashahikakupage_sozai2.png"
                  alt="Servo Spindle for Gun Drilling Machine"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>

            <div className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100">
              <h3 className="text-2xl font-bold text-[#001E3C] mb-6">Flexible Chucking Technology</h3>
              <p className="text-gray-600 mb-8 leading-relaxed text-lg">
                Freely interchangeable chucks adapt to various workpiece shapes and requirements.
              </p>
              <div className="w-full h-[220px] rounded-xl overflow-hidden">
                <img
                  src="https://www.hi-tak.co.jp/wp-content/uploads/2021/01/IMG_0385-1-1024x768.jpg"
                  alt="Scroll Chuck for Small Diameter Gun Drilling Machine"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>

            <div className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100">
              <h3 className="text-2xl font-bold text-[#001E3C] mb-6">Optimized Chip Box</h3>
              <p className="text-gray-600 mb-8 leading-relaxed text-lg">
                Hole diameter-specific optimization enhances machining precision and stability.
              </p>
              <div className="w-full h-[220px] rounded-xl overflow-hidden">
                <img
                  src="https://www.hi-tak.co.jp/wp-content/uploads/2021/01/tashahikakupage_sozai-722x1024.png"
                  alt="Chip Box for Gun Drilling Machine/Small Diameter Deep Hole Drilling"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Applications Section */}
      <section className="py-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-20">
            <span className="text-[#00D9C9] text-sm font-bold tracking-widest uppercase">Applications</span>
            <h2 className="text-4xl lg:text-6xl font-bold text-[#001E3C] mt-4 mb-6">
              HI-TAK Gun Drills Across Industries
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Our small diameter gun drilling machines can drill holes in components used across various industries and equipment. Our expertise in contract processing has helped customers improve their production processes by drilling pre-machined workpieces.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-10">
            {/* Medical Field */}
            <div className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200">
              <div className="relative w-full h-[280px] overflow-hidden">
                <img
                  src="https://www.hi-tak.co.jp/wp-content/uploads/2017/01/sample.jpg"
                  alt="Medical Field Deep Hole Drilling"
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-10">
                <h3 className="text-3xl font-bold text-[#001E3C] mb-6">Medical Field</h3>
                <ul className="space-y-3 text-gray-600 text-lg">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                    <span>Neurosurgical Bone Cutters</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                    <span>Implants (Femoral)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                    <span>Surgical Tools for Implants</span>
                  </li>
                </ul>
                <a
                  href="https://www.hi-tak.co.jp/%e5%8c%bb%e7%99%82%e7%b3%bb%e5%99%a8%e5%85%b7%e3%83%bc%e5%b0%8f%e5%be%84%e6%b7%b1%e7%a9%b4%e5%8a%a0%e5%b7%a5/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-[#00D9C9] font-bold mt-6 hover:gap-4 transition-all duration-300 text-lg"
                >
                  Learn More
                  <i className="ri-arrow-right-line w-6 h-6 flex items-center justify-center"></i>
                </a>
              </div>
            </div>

            {/* Automotive Field */}
            <div className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200">
              <div className="relative w-full h-[280px] overflow-hidden">
                <img
                  src="https://www.hi-tak.co.jp/wp-content/uploads/2017/02/gaikei.jpg"
                  alt="Automotive Field Deep Hole Drilling"
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-10">
                <h3 className="text-3xl font-bold text-[#001E3C] mb-6">Automotive Field</h3>
                <ul className="space-y-3 text-gray-600 text-lg">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                    <span>Molds (Cooling Water Core Pins)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                    <span>Shaft Components (Hollow Holes)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                    <span>Piston Connecting Rods (Oil Supply Holes)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                    <span>Fuel Injection Nozzle Components (Lower Body)</span>
                  </li>
                </ul>
                <a
                  href="https://www.hi-tak.co.jp/%e8%87%aa%e5%8b%95%e8%bb%8a%e9%83%a8%e5%93%81/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-[#00D9C9] font-bold mt-6 hover:gap-4 transition-all duration-300 text-lg"
                >
                  Learn More
                  <i className="ri-arrow-right-line w-6 h-6 flex items-center justify-center"></i>
                </a>
              </div>
            </div>

            {/* Machine Tools & Industrial Machinery */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200">
              <h3 className="text-3xl font-bold text-[#001E3C] mb-6">Machine Tools & Industrial Machinery</h3>
              <ul className="space-y-3 text-gray-600 mb-8 text-lg">
                <li className="flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                  <span>Motor Shafts (Hollow Holes)</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                  <span>Spindle Shafts (Hollow Holes)</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                  <span>Piston Cylinders (Oil Supply Piston Holes)</span>
                </li>
              </ul>
              <div className="grid grid-cols-3 gap-4">
                <div className="w-full h-[140px] rounded-xl overflow-hidden">
                  <img
                    src="https://www.hi-tak.co.jp/wp-content/uploads/2017/01/work06.jpg"
                    alt="Machine Tool Components"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-full h-[140px] rounded-xl overflow-hidden">
                  <img
                    src="https://www.hi-tak.co.jp/wp-content/uploads/2017/01/work05.jpg"
                    alt="Industrial Machinery Components"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-full h-[140px] rounded-xl overflow-hidden">
                  <img
                    src="https://www.hi-tak.co.jp/wp-content/uploads/2017/01/work04.jpg"
                    alt="Machinery Components"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Other Industries */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200">
              <h3 className="text-3xl font-bold text-[#001E3C] mb-6">Other Industries</h3>
              <ul className="space-y-3 text-gray-600 mb-8 text-lg">
                <li className="flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                  <span>Aerospace</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                  <span>Oil & Gas Plants</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                  <span>Renewable Energy</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                  <span>Semiconductors</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-arrow-right-s-line text-[#00D9C9] text-2xl flex-shrink-0"></i>
                  <span>Resin Materials</span>
                </li>
              </ul>
              <div className="grid grid-cols-2 gap-4">
                <div className="w-full h-[170px] rounded-xl overflow-hidden">
                  <img
                    src="https://www.hi-tak.co.jp/wp-content/uploads/2021/01/spacex-9dF7pCyaM9s-unsplash-1024x683.jpg"
                    alt="Aerospace Field"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-full h-[170px] rounded-xl overflow-hidden">
                  <img
                    src="https://www.hi-tak.co.jp/wp-content/uploads/2021/01/semi4_img.png"
                    alt="Semiconductor Field"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Technical Specifications */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">
              Technical Specifications
            </h2>
            <p className="text-xl text-white/70">
              Industry-leading precision and performance
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                icon: 'ri-ruler-line',
                title: 'Drilling Diameter',
                value: 'φ0.5~30mm',
                description: 'Wide range capability'
              },
            ].map((spec, index) => (
              <div key={index} className="space-y-4">
                <div className="flex items-center gap-3">
                  <i className={`${spec.icon} text-2xl text-[#00D9C9]`}></i>
                  <h4 className="text-xl font-bold text-[#001E3C]">{spec.title}</h4>
                </div>
                <p className="text-lg text-white/80">{spec.value}</p>
                <p className="text-sm text-white/60">{spec.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-gradient-to-br from-[#00D9C9]/10 to-[#00F5E0]/5 rounded-3xl p-12 border border-[#00D9C9]/20 backdrop-blur-sm">
            <h2 className="text-4xl font-bold text-white mb-6">
              Ready to Experience HI-TAK Precision?
            </h2>
            <p className="text-xl text-white/70 mb-8">
              Contact our team to discuss your gun drilling requirements and discover how our technology can enhance your manufacturing process.
            </p>
            <div className="flex flex-wrap gap-6 justify-center">
              <a
                href="mailto:info@hi-tak.co.jp?subject=Inquiry about Gun Drilling Systems"
                className="group bg-[#00D9C9] text-[#001E3C] px-12 py-5 rounded-xl font-bold hover:bg-[#00F5E0] hover:shadow-2xl hover:shadow-[#00D9C9]/50 transition-all duration-300 flex items-center gap-3 whitespace-nowrap cursor-pointer text-lg"
              >
                Email Us
                <i className="ri-mail-line text-2xl w-6 h-6 flex items-center justify-center"></i>
              </a>
              <a
                href="tel:+81-55-939-5581"
                className="group bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-12 py-5 rounded-xl font-bold hover:border-[#00D9C9] hover:bg-[#00D9C9]/10 transition-all duration-300 flex items-center gap-3 whitespace-nowrap text-lg"
              >
                <i className="ri-phone-line text-2xl w-6 h-6 flex items-center justify-center"></i>
                +81-55-939-5581
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
